export const textNotEmptyValidator = (text?: string) =>
  !!text && text.trim().length > 0
